import React, { useState } from "react";
import { Button, Space, Tag, Tooltip, Typography } from "antd";

const { Text } = Typography;
const AIRPORT_PREVIEW_LIMIT = 8;

function formatAirportSummary(metrics = {}) {
    const airportCodes = metrics.airportCodes || [];
    if (!airportCodes.length) {
        return "无机场";
    }

    const visibleAirports = airportCodes.slice(0, AIRPORT_PREVIEW_LIMIT).join(" / ");
    const remainingCount = airportCodes.length - AIRPORT_PREVIEW_LIMIT;
    return `${metrics.airportCount ?? airportCodes.length} 个：${visibleAirports}${remainingCount > 0 ? ` / +${remainingCount}` : ""}`;
}

function formatStcDistribution(metrics = {}) {
    const stcDistribution = metrics.stcDistribution || [];
    if (!stcDistribution.length) {
        return "无 STC 数据";
    }

    return stcDistribution.map((item) => `${item.type} ${item.count}`).join(" / ");
}

function MetricItem({ label, value, detail }) {
    return (
        <div className="schedule-draft-timetable-metric-item">
            <Text type="secondary" className="schedule-draft-timetable-metric-label">{label}</Text>
            <Text strong className="schedule-draft-timetable-metric-value">{value}</Text>
            {detail ? <Text type="secondary" className="schedule-draft-timetable-metric-detail">{detail}</Text> : null}
        </div>
    );
}

const TimetableMetrics = ({ metrics = {} }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <section className="schedule-draft-timetable-metrics" aria-label="表格摘要">
            <div className="schedule-draft-timetable-metrics-header">
                <Space wrap size={[8, 6]} className="schedule-draft-timetable-metrics-summary">
                    <Text strong>表格摘要</Text>
                    <Tag color="blue">航班 {metrics.flightCount ?? 0}</Tag>
                    <Tag>飞机 {metrics.aircraftCount ?? 0}</Tag>
                    <Tag>总飞行 {metrics.totalBlockTime || "--"}</Tag>
                </Space>
                <Space size={6}>
                    <Tooltip title="指标只读派生自当前本地表格模型，不作为业务事实源。">
                        <Text type="secondary">只读指标</Text>
                    </Tooltip>
                    <Button type="link" size="small" onClick={() => setExpanded((current) => !current)}>
                        {expanded ? "收起指标" : "展开指标"}
                    </Button>
                </Space>
            </div>
            {expanded ? (
                <>
                    <div className="schedule-draft-timetable-metrics-grid">
                        <MetricItem label="航班数" value={metrics.flightCount ?? 0} detail="当前可见航班行" />
                        <MetricItem label="飞机数" value={metrics.aircraftCount ?? 0} detail="按机号去重" />
                        <MetricItem label="航线数" value={metrics.routeCount ?? 0} detail="起降机场对" />
                        <MetricItem label="总飞行时间" value={metrics.totalBlockTime || "--"} detail="汇总 Block Time" />
                        <MetricItem label="总地面时间" value={metrics.totalGroundTime || "--"} detail={`汇总 ${metrics.groundTimeSegmentCount ?? 0} 个过站值`} />
                        {metrics.rotationCount ? <MetricItem label="轮换数" value={metrics.rotationCount} detail="按本地字段去重" /> : null}
                    </div>
                    <Space wrap size={[8, 8]} className="schedule-draft-timetable-metrics-details">
                        <Tag color="blue">涉及机场：{formatAirportSummary(metrics)}</Tag>
                        <Tag color="purple">航班性质分布：{formatStcDistribution(metrics)}</Tag>
                    </Space>
                </>
            ) : null}
        </section>
    );
};

export default TimetableMetrics;
